module.exports = __webpack_public_path__ + "img/maxcdn.1191ec08.svg";